@if (canEdit) {
  <ng-select
    id="routingProfile"
    #routingProfileSelectBox
    [clearable]="false"
    [controlName]="formControlName"
    [items]="typeahead"
    [ngModel]="value"
    (ngModelChange)="updateValue($event)"
    bindLabel="label"
    bindValue="value"
    portalInputValidityState
  >
    <ng-template let-item="item" ng-label-tmp>
      <span>{{ item.meta?.name }}</span>
      @if (item.meta?.description) {
        <small class="ms-1 text-muted">{{ item.meta.description }}</small>
      }
    </ng-template>
    <ng-template let-item="item" ng-option-tmp>
      <div>{{ item.meta.name }}</div>
      @if (item.meta.description) {
        <small class="text-muted text-wrap">{{ item.meta.description }}</small>
      }
    </ng-template>
  </ng-select>
} @else {
  @if (routingGroup) {
    <div>{{ routingGroup.name }}</div>
    @if (routingGroup.description) {
      <small class="text-muted">{{ routingGroup.description }}</small>
    }
  } @else {
    <div>{{ 'general.notSet' | portalTranslate }}</div>
  }
}
